import { useField, useForm } from "vee-validate";
import { computed, type Ref } from "vue";
import { useI18n } from "vue-i18n";
import { object as yupObject, string as yupString } from "yup";
import type { InitialRegistrationData } from "@/app/registration-app/user/shared/@types/InitialRegistrationData";
import type { PreRegistrationValidationData } from "@/app/registration-app/user/shared/@types/PreRegistrationValidationData";

export const usePreRegistrationValidationFields = (
  initialData?: InitialRegistrationData,
  showDocumentIdField?: Ref<boolean | undefined>,
) => {
  const { t } = useI18n();
  const validationSchema = computed(() => {
    return yupObject({
      customerId: yupString()
        .trim()
        .required(t("shared.form.validation.required")),
      documentId: yupString()
        .trim()
        .test(
          "required-when-shown",
          t("shared.form.validation.required"),
          (value) => !showDocumentIdField?.value || !!value,
        ),
      email: yupString()
        .trim()
        .email(t("shared.form.validation.email"))
        .required(t("shared.form.validation.required")),
    });
  });

  const { handleSubmit, resetForm } = useForm<PreRegistrationValidationData>({
    validationSchema,
  });
  const customerId = useField<string>("customerId", undefined, {
    initialValue: initialData?.customerNumber,
  });
  const documentId = useField<string>("documentId", undefined, {
    initialValue: initialData?.invoiceNumber ?? "",
  });
  const email = useField<string>("email", undefined, {
    initialValue: initialData?.email,
  });

  return {
    handleSubmit,
    resetForm,
    customerId,
    documentId,
    email,
  };
};
